import { AfterViewInit, Component, ElementRef, Inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { DirectionService } from '../../../shared/services/direction.service';
import { isPlatformBrowser } from '@angular/common';
import { ShopService } from 'src/app/shared/api/shop.service';
import { Collection } from 'src/app/shared/interfaces/custom/collection';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

@Component({
    selector: 'app-block-collections',
    templateUrl: './block-collections.component.html',
    styleUrls: ['./block-collections.component.scss']
})
export class BlockCollectionsComponent implements AfterViewInit {
    header = 'Collezioni';
    collections: Collection[];
    show = false;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private direction: DirectionService,
        private shop : ShopService,
        private http : HttpClient
    ) {

        // NOTA: endpoint "Collections" eliminato dal backoffice (risponde 404). Codice commentato il 2026-07-29,
        // lasciato per riferimento futuro nel caso torni disponibile un nuovo endpoint equivalente.
        // this.http.get('/assets/config/collezioni_ordine.txt').subscribe((ordine:number[])=> {
        //     if (ordine && Array.isArray(ordine) && ordine.length) {
        //         this.shop.getCollections()
        //         .subscribe(collections => {
        //             let orderedCollections = [];
        //             for (let id of ordine) {
        //                 let found = collections.find(collection => collection.id == String(id));
        //                 if (found)
        //                     orderedCollections.push(found);
        //             }
        //             this.collections = orderedCollections.slice(0, 5);
        //             this.show = true;
        //         })
        //     }
        // });

    }

    ngAfterViewInit(): void {
        
    }
}
